import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import PartialTable from 'components/partials/PartialTable';
import { useSortBe } from 'hooks/useBeHandle';
import { formatStoreNote } from './StockRequestType';

function StockRequestTable({
  data,
  paging,
  total,
  nextPage,
  previousPage,
  gotoPage,
  colSort,
  handleSort,
  selectedCancelIds,
  setSelectedCancelIds
}) {
  const { t } = useTranslation();

  const toggleCancelId = id => {
    setSelectedCancelIds(prev =>
      prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
    );
  };

  const originColumns = useMemo(
    () => [
      {
        accessor: 'dateTimeRequested',
        Header: t('colDateTimeRequested'),
        Cell: rowData => {
          const value = rowData.row.original.dateTimeRequested;
          return value ? moment(value).format('DD/MM/YYYY HH:mm') : '';
        }
      },
      {
        accessor: 'requestedByName',
        Header: t('colRaisedBy')
      },
      {
        accessor: 'emplasCode',
        Header: t('colEmplasCode')
      },
      {
        accessor: 'supplierCode',
        Header: t('colSupplierCode')
      },
      {
        accessor: 'description',
        Header: t('colDescription'),
        cellProps: {
          style: { whiteSpace: 'normal', minWidth: 280, maxWidth: 480 }
        }
      },
      {
        accessor: 'qty',
        Header: t('colQty')
      },
      {
        accessor: 'notesFromStores',
        Header: t('colNotesFromStores'),
        disableSortBy: true,
        Cell: rowData => formatStoreNote(t, rowData.row.original)
      },
      {
        accessor: 'cancel',
        Header: t('colCancel'),
        disableSortBy: true,
        Cell: rowData => {
          const id = rowData.row.original.id;
          return (
            <Form.Check
              type="checkbox"
              checked={selectedCancelIds.includes(id)}
              onChange={() => toggleCancelId(id)}
            />
          );
        }
      }
    ],
    [t, selectedCancelIds]
  );

  const [columns, setColumns] = useState([]);
  const { reNewColumns } = useSortBe(
    originColumns,
    colSort,
    setColumns,
    columns
  );

  useEffect(() => {
    reNewColumns();
  }, [colSort, originColumns]);

  return (
    <PartialTable
      data={data}
      columns={columns}
      paging={paging}
      total={total}
      nextPage={nextPage}
      previousPage={previousPage}
      gotoPage={gotoPage}
      beSortOption={{ canSort: true, handleSort }}
      handleClickRow={() => {}}
    />
  );
}

StockRequestTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  paging: PropTypes.object,
  total: PropTypes.number,
  nextPage: PropTypes.func,
  previousPage: PropTypes.func,
  gotoPage: PropTypes.func,
  colSort: PropTypes.object,
  handleSort: PropTypes.func,
  selectedCancelIds: PropTypes.array,
  setSelectedCancelIds: PropTypes.func
};

export default StockRequestTable;
